import { t } from "i18next"

import { statusTextMap, tagColorMap, tagMap } from "../../../Utils/utils"

// error_rate is null when the endpoint had no deliveries in the last 7 days —
// that is not the same as a real 0% error rate.
export const formatErrorRate = (value) => (value == null ? t("No events yet") : `${value}%`)

export const getEndpointStatusView = ({ status, error_rate } = {}) => {
  const key = status?.toLowerCase()

  // Active but never delivered anything — keep it neutral instead of green.
  if (key === "active" && error_rate == null) {
    return {
      tagColor: "default",
      badgeStatus: "default",
      badgeColor: undefined,
      text: t("Active · no events yet")
    }
  }

  return {
    tagColor: tagMap[key] || "default",
    badgeStatus: tagMap[key] || "default",
    badgeColor: tagColorMap[status],
    text: statusTextMap[status] || status
  }
}
